module.exports = __webpack_public_path__ + "media/images/pages/ai/pocstock-ethical-ai-face-18@2x-9f04018f54e2dc4fb14fa253c4a987cc.png";